module.exports = __webpack_public_path__ + "img/养老机构.db1541d7.png";